export default __webpack_public_path__ + "static/logo-fe5d2d94d4ef048de9f79fd0330c0a38.svg";